import * as React             from "react";
import * as ReactDOM          from "react-dom";
import {createBrowserHistory} from "history";

import {CustomerSupportChat} from "@Common/ui-components/customer-support-chat";
import {cs}                  from "@Common/react/chain-services";
import {provideContext}      from "@Common/react/context";

import {loadApis}             from "./loaders/apis/apis";
import {loadCart2}            from "./loaders/load-cart-2";
import {loadCatSubStyle}      from "./loaders/load-catSubStyle";
import {loadCompany}          from "./loaders/load-company";
import {loadMenu}             from "./loaders/load-menus";
import {loadScheme}           from "./loaders/load-scheme";
import {loadUserLevels}       from "./loaders/load-user-levels";
import {loadSession}          from "./loaders/session/load-session";
import {InternalLinkProvider} from "./routes/common/components/internal-link";
import {ErrorBoundary}        from "./routes/common/error-boundary";
import {LayoutDesktopHeader}  from "./routes/layout/desktop/header/header";
import {LayoutFooter}         from "./routes/layout/footer/footer";

export const bootstrapPhpIntegration = (headerDom, footerDom) => cs(
    (_, next) => ReactDOM.render(next(), headerDom),
    (_, next) => <ErrorBoundary {...{
        next,
    }}/>,

    (_, next) => <InternalLinkProvider value={(to) => window.location.href = `${process.env.PUBLIC_URL.replace(/\/$/,"")}/${to.replace(/^\//,"")}`}>{next()}</InternalLinkProvider>,

    ({}, next) => loadApis({
        next,
        onUnauthorized: () => {},
    }),

    ({}, next) => cs(
        ["themeScheme", ({}, next) => loadScheme({next})],
        ({themeScheme}, next) => provideContext({routerHistory: createBrowserHistory({
            basename: process.env.PUBLIC_URL + (themeScheme?.companyXdocsUrl ? ('/' + themeScheme?.companyXdocsUrl) : ''),
        })}, next),
        ({themeScheme}, next) => !themeScheme ? (
            "Loading theme..."
        ) : (
            next()
        ),
        ({themeScheme}, next) => themeScheme.type === "loggedIn" ? cs(
            ["userLevels", (_, next) => loadUserLevels(next)],
            ["company", ({}, next) => loadCompany(next)],
            ({company, userLevels}, next) => loadSession({company, userLevels, next}),
            ({}, next) => loadMenu(next),
            ({}, next) => loadCatSubStyle(next),
            ({}, next) => loadCart2(next),

            ({userLevels}, next) => LoadingMessages({userLevels, next}),
            ({userLevels}, next) => provideContext({
                userLevels: userLevels.value,
                themeScheme,
            }, next),
            next,
        ) : cs(
            ({}, next) => provideContext({themeScheme}, next),
            next,
        ),
        next,
    ),

    () => <>
        <LayoutDesktopHeader/>
        {ReactDOM.createPortal(LayoutFooter({}), footerDom)}
        <CustomerSupportChat/>
    </>,
);

const LoadingMessages = ({userLevels, next}) => (
    userLevels.loading ? (
        "Loading user level..."
    ) : (
        next()
    )
);

